(function (root, doc) {
    'use strict';
    var box = doc.querySelector('[data-widoki-wynikow]');
    if (!box) return;
    var game = box.getAttribute('data-gra');
    var allowedGames = ['lotto', 'lotto-plus', 'mini-lotto', 'multi-multi', 'eurojackpot'];
    if (allowedGames.indexOf(game) < 0) return;
    var key = 'pewniaki:widoki-wynikow:v1';
    var input = box.querySelector('[data-widoki-name]');
    var select = box.querySelector('[data-widoki-list]');
    var status = box.querySelector('[data-widoki-status]');
    var table = doc.querySelector('[data-wyniki]');
    if (!input || !select || !status || !table) return;

    function read() {
        var raw = root.localStorage.getItem(key);
        if (!raw) return { version: 1, games: {} };
        var data = JSON.parse(raw);
        if (!data || data.version !== 1 || !data.games || typeof data.games !== 'object') throw Error('format');
        return data;
    }
    function message(name) { status.textContent = box.getAttribute('data-' + name) || ''; }
    function entries(data) {
        if (!Array.isArray(data.games[game])) data.games[game] = [];
        return data.games[game];
    }
    function render(selected) {
        var items = entries(read());
        select.length = 1;
        items.forEach(function (item) {
            if (!item || typeof item.id !== 'string' || typeof item.name !== 'string') return;
            var option = doc.createElement('option');
            option.value = item.id;
            option.textContent = item.name;
            select.appendChild(option);
        });
        if (selected) select.value = selected;
        box.querySelector('[data-widoki-open]').disabled = !select.value;
        box.querySelector('[data-widoki-remove]').disabled = !select.value;
    }
    function capture() {
        var result = {};
        var range = table.querySelector('[data-wyniki-ile]');
        var anchor = table.querySelector('[data-wyniki-od]');
        var search = table.querySelector('[data-wyniki-szukaj]');
        var layout = table.querySelector('[data-wyniki-uklad]');
        var overlay = table.querySelector('[data-lotto-overlay-toggle]');
        if (range && /^(?:all|[1-9]\d{0,3})$/.test(range.value)) result.ile = range.value;
        if (anchor && /^[1-9]\d{0,8}$/.test(anchor.value)) result.od = anchor.value;
        if (search && search.value.trim()) result.szukaj = search.value.trim().slice(0, 60);
        if (layout && layout.getAttribute('aria-pressed') === 'true') result.uklad = 'powtorzenia';
        if (overlay && overlay.getAttribute('aria-pressed') === 'true') result.warstwa = '1';
        ['nr', 'data'].forEach(function (field) {
            var heading = table.querySelector('[data-sort="' + field + '"]');
            if (heading && ['ascending', 'descending'].indexOf(heading.getAttribute('aria-sort')) >= 0) {
                result.sort = field + '-' + (heading.getAttribute('aria-sort') === 'ascending' ? 'asc' : 'desc');
            }
        });
        ['dopasuj', 'osie', 'rytmy'].forEach(function (action) {
            var button = table.querySelector('[data-sw-akcja="' + action + '"]');
            if (button && button.getAttribute('aria-pressed') === 'true') result[action] = '1';
        });
        if (table.swWidok && Number.isFinite(table.swWidok.s) && table.swWidok.fit > 0 && result.dopasuj === '1') {
            result.skala = String(Math.round(table.swWidok.s / table.swWidok.fit * 100) / 100);
        }
        var current = new URL(root.location.href).searchParams;
        ['chart', 'chartNumbers', 'chartWindow', 'chartSegment', 'chartPool', 'liczba'].forEach(function (name) {
            var value = current.get(name);
            if (value && value.length <= 100) result[name] = value;
        });
        return result;
    }
    function safeParams(params) {
        var allowed = ['ile', 'od', 'szukaj', 'uklad', 'warstwa', 'sort', 'dopasuj', 'osie', 'rytmy', 'skala',
            'chart', 'chartNumbers', 'chartWindow', 'chartSegment', 'chartPool', 'liczba'];
        var result = new URLSearchParams();
        if (!params || typeof params !== 'object') return result;
        allowed.forEach(function (name) {
            var value = params[name];
            if (typeof value === 'string' && value.length <= 100 && !/[\u0000-\u001f]/.test(value)) result.set(name, value);
        });
        return result;
    }
    function save() {
        var name = input.value.trim().replace(/\s+/g, ' ').slice(0, 60);
        if (!name) { input.focus(); message('error'); return; }
        try {
            var data = read(), items = entries(data);
            var item = items.find(function (entry) { return entry.name.toLocaleLowerCase() === name.toLocaleLowerCase(); });
            if (!item && items.length >= 10) { message('limit'); return; }
            if (!item) {
                item = { id: Date.now().toString(36) + Math.random().toString(36).slice(2, 8), name: name };
                items.push(item);
            }
            item.name = name;
            item.params = capture();
            item.savedAt = new Date().toISOString();
            root.localStorage.setItem(key, JSON.stringify(data));
            render(item.id);
            message('saved');
        } catch (e) { message('error'); }
    }
    function open() {
        try {
            var item = entries(read()).find(function (entry) { return entry.id === select.value; });
            if (!item) return;
            var url = new URL(root.location.pathname, root.location.origin);
            url.search = safeParams(item.params).toString();
            url.searchParams.set('widok', item.id);
            url.hash = 'historia-losowan';
            root.location.assign(url.href);
        } catch (e) { message('error'); }
    }
    function remove() {
        try {
            var data = read(), items = entries(data), id = select.value;
            data.games[game] = items.filter(function (item) { return item.id !== id; });
            if (data.games[game].length === items.length) return;
            root.localStorage.setItem(key, JSON.stringify(data));
            render();
            message('removed');
        } catch (e) { message('error'); }
    }
    try {
        read();
        box.hidden = false;
        render(new URL(root.location.href).searchParams.get('widok'));
        box.querySelector('[data-widoki-save]').addEventListener('click', save);
        box.querySelector('[data-widoki-open]').addEventListener('click', open);
        box.querySelector('[data-widoki-remove]').addEventListener('click', remove);
        select.addEventListener('change', function () { render(select.value); });
    } catch (e) { box.hidden = true; }
})(window, document);
